<template>
  <div id="app">
    <div class="container-fluid">
      <div class="row flex-nowrap-sm">
        <Sidebar />
        <div class="main ml-3">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from './container/Sidebar.vue'
export default {
  name: 'App',
  components: {
    Sidebar
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue